import React, { useState } from "react";
import { Form, Button } from "@themesberg/react-bootstrap";
import Select from "react-select";
import { useTranslation } from "react-i18next";

export default function Filter({ fields = [], initialValues = {}, onFilterChange }) {
  const [filters, setFilters] = useState(initialValues);
  const { t } = useTranslation();

  const handleChange = (name, value) => {
    const updated = { ...filters, [name]: value };
    setFilters(updated);
    if (onFilterChange) onFilterChange(updated);
  };

  const handleClear = () => {
    setFilters({});
    if (onFilterChange) onFilterChange({});
  };

  return (
    <Form
      className="mb-0"
      style={{ display: "flex", gap: "8px", alignItems: "center" }}
    >
      {fields.map((field) => (
        <Form.Group
          controlId={field.name}
          key={field.name}
          style={{ flex: field.col || 1, marginBottom: 0, marginTop: 0 }}
        >
          {field.type === "select" ? (
            <Select
              classNamePrefix="react-select"
              options={[{ value: "", label: "All" }, ...(field.options || [])]}
              value={
                field.options?.find((opt) => opt.value === filters[field.name]) ||
                (filters[field.name] === "" ? { value: "", label: "All" } : null)
              }
              onChange={(selected) =>
                handleChange(field.name, selected ? selected.value : "")
              }
              placeholder="All"
              isClearable
              menuPortalTarget={document.body} 
              
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: "32px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  width: "250px",
                  boxShadow: state.isFocused ? "0 0 0 1px #4f46e5" : base.boxShadow,
                  borderColor: state.isFocused ? "#4f46e5" : base.borderColor,
                  "&:hover": { borderColor: "#4f46e5" },
                }),
                option: (base, state) => ({
                  ...base,
                  fontSize: "14px",
                  padding: "6px 12px",
                  backgroundColor: state.isSelected
                    ? "#4f46e5"
                    : state.isFocused
                      ? "#e0e7ff"
                      : "white",
                  color: state.isSelected ? "white" : "black",
                }),
                singleValue: (base) => ({
                  ...base,
                  fontSize: "14px",
                  color: "#111827",
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: "14px",
                  color: "#6b7280",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ ensure on top
              }}
            />
          ) : (
            <Form.Control
              style={{ width: "100%" }}
              type={field.type || "text"}
              placeholder={field.placeholder || ""}
              value={filters[field.name] || ""}
              onChange={(e) => handleChange(field.name, e.target.value)}
            />
          )}
        </Form.Group>
      ))}
      <Button
        variant="primary"
        onClick={handleClear}
        style={{ height: "fit-content", marginTop: 0 }}
      >
        {t("buttons.clear")}
      </Button>
    </Form>
  );
}
